export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15')
];

export const server_loads = [];

export const dictionary = {
		"/": [~2],
		"/dining": [~3],
		"/dining/[slug]": [~4],
		"/festive-season-2024": [~5],
		"/gallery": [~6],
		"/leisure": [~7],
		"/meeting-event": [~8],
		"/meeting-event/[slug]": [~9],
		"/offer": [~10],
		"/offer/[slug]": [~11],
		"/room-villa": [~12],
		"/room-villa/[slug]": [~13],
		"/special-partners-privileges": [~14],
		"/thg-apps": [~15]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),

	reroute: (() => {})
};

export { default as root } from '../root.svelte';